import React, { ReactElement } from 'react';
import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import { putDatumyOdDoToArray } from '../../../function/putDatumyOdDoToArray';

interface Props {
  filter: NavrhAktuEuFilter;
  onUpdateField: SafeParameterSetter<NavrhAktuEuFilter>;
  className?: string;
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void;
}
const FilterTagsComponent = ({
  filter,
  onUpdateField,
  className = '',
  onClearFilters = null,
}: Props): ReactElement => {
  const classes: string = classNames('elegislativa-filter-tag-component', className);

  return (
    <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
      <FilterTag
        title="Hľadaný výraz"
        data={filter.hladanyVyraz}
        onClear={() => {
          onUpdateField('hladanyVyraz', '');
        }}
      />
      <FilterTag
        title="Číslo procesu"
        data={filter.cisloLegislativnehoMaterialu}
        onClear={() => {
          onUpdateField('cisloLegislativnehoMaterialu', '');
        }}
      />
      <FilterTag
        title="Identifikátor aktu"
        data={filter.identifikatorAktu}
        onClear={() => {
          onUpdateField('identifikatorAktu', '');
        }}
      />
      <FilterTag
        title="Názov procesu"
        data={filter.nazovLegislativnehoMaterialu}
        onClear={() => {
          onUpdateField('nazovLegislativnehoMaterialu', '');
        }}
      />
      <FilterTag
        title="Názov aktu EÚ"
        data={filter.nazovAktu}
        onClear={() => {
          onUpdateField('nazovAktu', '');
        }}
      />
      <FilterTag
        title="Typ aktu"
        data={filter.type?.nazov}
        onClear={() => {
          onUpdateField('type', null);
        }}
      />
      <FilterTag
        title="Inštitúcia"
        data={filter.institucia?.nazov}
        onClear={() => {
          onUpdateField('institucia', null);
        }}
      />
      <FilterTag
        title="Medziinštitucionálny kód"
        data={filter.medziinstitucionalnyKod}
        onClear={() => {
          onUpdateField('medziinstitucionalnyKod', '');
        }}
      />
      <FilterTag
        title="Dátum prijatia"
        data={putDatumyOdDoToArray(filter.datumPrijatiaAktuOd, filter.datumPrijatiaAktuDo)}
        onClear={(title) => {
          if (title.startsWith('od')) {
            onUpdateField('datumPrijatiaAktuOd', undefined);
          }
          if (title.startsWith('do')) {
            onUpdateField('datumPrijatiaAktuDo', undefined);
          }
        }}
      />
    </FilterTagGroup>
  );
};

export default FilterTagsComponent;
